import { useGetAllTrayCapacitiesQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { trayCapacitiesColumns, type TrayCapacityRow } from '../constants/trayCapacitiesColumns';

export const TrayCapacitiesList = () => {
    const { loading, data, error } = useGetAllTrayCapacitiesQuery();

    if (loading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!data || error) {
        throw new Error('Une erreur est survenue lors de la récupération des bacs');
    }

    const { allTrayCapacities } = data;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<TrayCapacityRow>
                columns={trayCapacitiesColumns}
                data={allTrayCapacities}
                filterMode="client"
                getRowId={(row) => row.microstoreColumnId}
                getRowLink={(row) => `/microstore-column/${row.microstoreColumnId}`}
                searchPlaceholder="Nom du site, de la machine ou du template"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
